/* global GIT_SHA1 */
import React from 'react';
import ReactDom from 'react-dom';
import { onlyShowFocusOnTabs, GoogleButton } from 'seagull';
import * as Sentry from '@sentry/react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { AppWithEventReporter } from "./App";
import { Router } from 'react-router-dom';
import { IoContextProvider } from "./contexts";
import { StoreProvider } from "./store/StoreProvider";
import { MobileViewportWidthProvider } from "./providers/MobileViewportWidthProvider";
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import { PusherProvider } from "./pusher";
import Pusher from 'pusher-js';
import { usePlaidLink } from 'react-plaid-link';
import { mockIntercom } from "./providers/IoContext";
import { slackClient } from "./utils/slack-client";
import { personaClient } from "./hooks/usePersona";
import ReactPlayer from 'react-player';
import YouTubePlayer from 'react-player/youtube';
import { createBrowserHistory } from 'history';
import { initStoreApi } from "./store/store-api";
import * as loom from '@loomhq/loom-embed';
import { uploadFileToCloudStorage } from "./infra/utils";
import { RealCookiesManager } from "./providers/CookiesManager";
onlyShowFocusOnTabs();
const history = createBrowserHistory();
if (window.sentryEnvironment) {
  Sentry.init({
    dsn: 'https://ff94ed3a7d9149d3b85db4470ae506e1@o326813.ingest.sentry.io/1835583',
    environment: window.sentryEnvironment,
    integrations: [Sentry.reactRouterV5BrowserTracingIntegration({
      history
    })],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/(my|demo).anchor.sh/],
    release: GIT_SHA1,
    denyUrls: [/^chrome-extension:\/\//i, /^safari-extension:\/\//i, /clarity\.js/i, /adsscriptloaderstatic/i, /\/\/hidden\//i, /\/appcues/i, /googletagmanager\.com/i, /this\.nexusWebSocket/i, /\/collectedforms\.js/i,
    // hubspot
    /\/li.lms-analytics/i,
    // 3rd party analytics
    /\/hotjar/i, /\/frame-/i, /google-analytics\.com\/analytics\.js/i, /translate\.googleapis\.com/i, /translate\.google\.com/i, /msDiscoverChatAvailable/i],
    ignoreErrors: ["Failed to execute 'sendBeacon' on 'Navigator'", 'Error: Network Error', /__gCrWeb/, /\[Parchment\]/i, 'AxiosError: Request aborted', 'ResizeObserver loop limit exceeded'],
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click' || breadcrumb.category === 'ui.input') {
        var _hint$event;
        const testid = hint === null || hint === void 0 || (_hint$event = hint.event) === null || _hint$event === void 0 || (_hint$event = _hint$event.target) === null || _hint$event === void 0 || (_hint$event = _hint$event.dataset) === null || _hint$event === void 0 ? void 0 : _hint$event.testid;
        if (testid) {
          breadcrumb.message = testid;
        }
      }
      return breadcrumb;
    }
  });
  if (window._sessionId) {
    Sentry.setTag('sessionId', window._sessionId);
  }
}
const gtmParams = {
  id: window._gtmId
  // id: 'GTM-WNBV55S', //staging
};
const getPusher = () => {
  const pusher = new Pusher(window.pusherAppKey, {
    cluster: 'us2'
  });
  return {
    subscribe: channelName => {
      return pusher.subscribe(channelName);
    },
    unsubscribe: channelName => {
      return pusher.unsubscribe(channelName);
    },
    channel: channelName => {
      return pusher.channel(channelName);
    }
  };
};
const getHotjar = () => ({
  identify(userId, payload) {
    window.hj && window.hj('identify', userId, payload);
  }
});
const loomParser = url => loom.oembed(url);
ReactDom.render( /*#__PURE__*/React.createElement(Router, {
  history: history
}, /*#__PURE__*/React.createElement(IoContextProvider, {
  getNow: () => new Date(),
  usePlaidLink: usePlaidLink,
  slackClient: slackClient,
  locationReload: () => window.location.reload(),
  changeLocation: url => window.location.href = url,
  copyToClipboard: text => navigator.clipboard.writeText(text),
  getIntercom: () => window.Intercom || mockIntercom,
  getHotjar: getHotjar,
  openNewTab: function openNewTab() {
    return window.open(...arguments);
  },
  personaClient: personaClient,
  ReactPlayer: ReactPlayer,
  YoutubePlayer: YouTubePlayer,
  GoogleButton: GoogleButton,
  loomParser: loomParser,
  uploadFileToCloudStorage: uploadFileToCloudStorage,
  cookies: new RealCookiesManager(window._authDomain)
}, /*#__PURE__*/React.createElement(StoreProvider, {
  apiHost: window._apiHostname,
  mgmtHost: window._mgmtHostname,
  pdfHost: window._pdfHostname,
  apiGatewayHost: window._apiGatewayHostname,
  authDomain: window._authDomain,
  useAuthorizationHeader: window.useAuthorizationHeader,
  sessionTimeoutMS: window.sessionTimeoutMS,
  initStoreApi: initStoreApi
}, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
  utils: DateFnsUtils
}, /*#__PURE__*/React.createElement(GTMProvider, {
  state: gtmParams
}, /*#__PURE__*/React.createElement(PusherProvider, {
  pusher: getPusher()
}, /*#__PURE__*/React.createElement(MobileViewportWidthProvider, null, /*#__PURE__*/React.createElement(AppWithEventReporter, null)))))))), document.getElementById('main'));